import { GENERAL_SET } from "../const";
import { IGeneral } from "../actions/general";
import { ILanguage, SET_LANGUAGES } from "../yoello-lib/modules/redux/actions/localization";

export interface IGeneralState {
  [key: string]: any;
  languages?: ILanguage[];
}

const INITIAL_STATE: IGeneralState = {
};

const reducer = (state = INITIAL_STATE, action: IGeneral) => {
  switch (action.type) {
    case GENERAL_SET:
      return { ...state, [action.payload.key]: action.payload.value };
    case SET_LANGUAGES:
      return { ...state, languages: action.payload };
    default:
      return state;
  }
};

export default reducer;
